import calendar from "./calendar.vue";

export default [
  {
    name: "calendar",
    path: "/calendar",
    component: calendar,
  },
];
